import { Box, Button, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector, RootState } from "../../store";
import { useNavigate } from "react-router-dom";
import { getFormGroup, rmvMsgSccsFGr } from "../../store/feature/formGroup";

// icon
import AddIcon from "@mui/icons-material/Add";
import Toast from "../../components/atoms/toast";
import AdminRoleAccessSearch from "../../components/molecules/adminRoleAccess/AdminRoleAccessSearch";
import AdminRoleAccessTable from "../../components/molecules/adminRoleAccess/AdminRoleAccessTable";
import { getAdminRolesAcsList } from "../../store/feature/adminRolesAccess";
import ListDataSkeleton from "../../components/template/skeleton/ListDataSkeleton";

const AdminRoleAccess = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [params, setParams] = useState<object>({});
  const [defaultValue, setDefaultValue] = useState({});

  const { admRoleAcs } = useAppSelector((state: RootState) => state.user);
  const { isLoadingAdmRolesAcs, isLoadingEvent } = useAppSelector(
    (state: RootState) => state.admRoleAcs
  );
  const { dataFGroup, msgSccsFGr } = useAppSelector(
    (state: RootState) => state.fGroup
  );

  const handleCloseToast = () => {
    dispatch(rmvMsgSccsFGr());
  };

  useEffect(() => {
    dispatch(getAdminRolesAcsList(params));
  }, [params]);

  return (
    <ListDataSkeleton
      isLoading={isLoadingAdmRolesAcs}
      isLoadingEvent={isLoadingEvent}
      titleWidth={"300"}
    >
      <Box>
        <Typography
          variant="h3"
          fontFamily="Open Sans"
          sx={{ marginY: "20px" }}
        >
          User Roles Access
        </Typography>
        {admRoleAcs.uc_adm_pge_acs_create === 1 && (
          <Box sx={{ display: "flex", flexDirection: "row-reverse" }}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => navigate("/user-roles-access/create")}
              sx={{ marginBottom: "18px" }}
            >
              <AddIcon /> Create
            </Button>
          </Box>
        )}
        <AdminRoleAccessSearch params={params} setParams={setParams} />
        <AdminRoleAccessTable
          data={dataFGroup}
          params={params}
          setParams={setParams}
          defaultValue={defaultValue}
          setDefaultValue={setDefaultValue}
        />
        <Toast
          severity="success"
          open={msgSccsFGr !== ""}
          handleClose={handleCloseToast}
          message={msgSccsFGr}
        />
      </Box>
    </ListDataSkeleton>
  );
};

export default AdminRoleAccess;
